/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CapacityTemplateModel as DigiworkMaitreDPosDtoPosCapacityTemplateModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Pos/capacity-template-model';

export interface CreateCapacity$Params {
  
    /**
     * Name of the template
     */
    body?: DigiworkMaitreDPosDtoPosCapacityTemplateModel
}

export function createCapacity(http: HttpClient, rootUrl: string, params?: CreateCapacity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createCapacity.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createCapacity.PATH = '/api/gmn/Capacity/createcapacity';
